<template>
    <v-dialog width="600" v-model="showtripLogs">
        <v-card class="logsContainer">
            <v-card-title class="secondary white--text">
                <span> Trip Logs {{ tripDetails.trip_id }}</span>

                <v-spacer></v-spacer>

                <v-btn icon @click="showtripLogs = false">
                    <v-icon class="white--text">mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-timeline dense clipped>
                    <v-timeline-item v-for="(log, i) in tripDetails.trip_logs" :key="i" icon-color="primary" small>
                        <v-card class="elevation-2">
                            <v-card-title class="py-0">
                                <v-row>
                                    <v-col cols="6">
                                        <span class="text-subtitle-2" v-if="log.created_by">
                                            {{ log.created_by }}
                                        </span>
                                        <span class="text-subtitle-2" v-else>
                                            {{ log.added_by }}
                                        </span>
                                    </v-col>

                                    <v-col cols="6" class="text-right">
                                        <span class="text-caption">
                                            {{ log.log_timestamp | formatDate(true) }}
                                        </span>
                                    </v-col>
                                </v-row>
                            </v-card-title>
                            <v-card-text> {{ log.message }} </v-card-text>
                        </v-card>
                    </v-timeline-item>
                </v-timeline>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>


export default {
    components: {

    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        tripDetails: {
            type: Object,
            default: null,
        }


    },
    watch: {
        value(val) {
            if (val) {
                // this.getTripDetails(this.tripID)
            } else {
            }
        },
    },
    computed: {
        showtripLogs: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
    data() {
        return {
            isValid: true,
            isTextInput: false,
        };
    },
    methods: {







    },

};
</script>
